import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"com-mb-dialog normal",attrs:{"id":"info-dialog"}},[_c(VRow,{staticClass:"com-mb-dialog-header pa-0"},[_c('span',{staticClass:"com-mb-dialog-title"},[_vm._v("お知らせ情報詳細")]),_c(VSpacer),_c(VBtn,{attrs:{"small":"","icon":"","color":"white"},on:{"click":_vm.closeDlg}},[_c(VIcon,[_vm._v("highlight_off")])],1)],1),_c(VCol,{staticClass:"com-mb-dialog-contents pa-0"},[_c('if-detail')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }